import React, { useEffect, useState } from 'react';
import axios from 'axios';

import './styles/reset.css';
import './styles/style.css';
import './fonts/Inter/stylesheet.css';

import LoadingPage from './pages/loading/LoadingPage';
import LanguagesPage from './pages/languages/LanguagesPage';
import SubscribePage from './pages/subscribe/SubscribePage';
import NavigationPanel from './components/navigation/NavigationPanel';
import MapPage from './pages/map/MapPage';
import Search from './components/search/Search';
import AddEvent from './components/add-event/AddEvent';
import MapButton from './components/map-button/MapButton';
import MapDate from './components/map-date/MapDate';
import TypeEvents from './pages/type-events/TypeEvents';
import AddEvents from './pages/add-events/AddEvents';
import Chat from './pages/chat/Chat';
import User from './pages/user/User';
import MePoint from './pages/me-point/MePoint';
import EventsJoin from './pages/events-join/EventsJoin';

import ruTranslations from './lang/ru.json';
import enTranslations from './lang/en.json';
import { el } from 'date-fns/locale';
import RecommendPage from './pages/recommend-page/RecommendPage';
import AddRecommendPage from './pages/add-recommend/AddRecommendPage';

function App() {
    // состояние отображения компонентов
    // LoadingPage, LanguagesPage, SubscribePage, MapPage, TypeEventsPage, UserPage, MePointPage, AddEventPage, EventJoinPage, ChatPage
    // NewMapPage, NewTypeEvents
    const [currentPage, setCurrentPage] = useState('LoadingPage');

    // отображение навигации в чатах
    const [isShowNavigation, setIsShowNavigation] = useState(true);

    // ссылка на тг канал
    const [channelLink, setChannelLink] = useState(null);

    //координаты пользователя
    const [userlatitude, setUserlatitude] = useState(null);
    const [userlongitude, setUserlongitude] = useState(null);
    const [mapCenter, setMapCenter] = useState([55.7522, 37.6156]);

    // const [userLang, setUserLang] = useState(null);
    const userLang = localStorage.getItem('userLanguage');

    // категории мероприятий
    const [categories, setСategories] = useState([]);

    // сегодня, завтра, послезавтра
    const [typeOfDate, setTypeOfDate] = useState(null);

    // подкатегории для запроса
    const [eventSubCategory, setEventSubCategory] = useState(null);
    const [eventSubCategoryId, setEventSubCategoryId] = useState(null);

    // состояния для создания мероприятия
    const [newEventAddress, setNewEventAddress] = useState(null);
    const [newEventCoords, setNewEventCoords] = useState(null);
    const [newEventCategory, setNewEventCategory] = useState(null);
    const [newEventDate, setNewEventDate] = useState(null);
    const [newEventDescription, setNewEventDescription] = useState(null);
    const [newEventCount, setNewEventCount] = useState(2);

    // состояние для информации о мероприятии
    const [eventInfo, setEventInfo] = useState(null);

    // мероприятия
    const [events, setEvents] = useState([]);

    // состояния для создания рекомендации
    const [newRecommendCategory, setNewRecommendCategory] = useState(null);
    const [newRecommendNameRu, setNewRecommendNameRu] = useState(null);
    const [newRecommendNameEn, setNewRecommendNameEn] = useState(null);
    const [newRecommendDescriptionRu, setNewRecommendDescriptionRu] =
        useState(null);
    const [newRecommendDescriptionEn, setNewRecommendDescriptionEn] =
        useState(null);

    const [newRecommendAddress, setNewRecommendAddress] = useState(null);
    const [newRecommendCoords, setNewRecommendCoords] = useState(null);
    const [image, setImage] = useState(null);
    const [newRecommendDate, setNewRecommendDate] = useState(null);
    const [newRecommendId, setNewRecommendId] = useState(null);

    // состояния для экрана "пользователь"
    const [isShowUserButtons, setIsShowUserButtons] = useState(true);
    const [isShowUserRecommend, setIsShowUserRecommend] = useState(false);
    const [isShowUserNotifications, setIsShowUserNotifications] =
        useState(false);

    const [isFullScreenMode, setIsFullScreenMode] = useState(false);

    // кнопка "Назад" в тг
    useEffect(() => {
        const tg = window.Telegram.WebApp;

        if (currentPage === 'EventJoinPage') {
            tg.BackButton.show();
            tg.BackButton.onClick(() => {
                setCurrentPage('MapPage');
            });
        } else if (currentPage === 'NewTypeEvents') {
            tg.BackButton.show();
            tg.BackButton.onClick(() => {
                setCurrentPage('AddEventPage');
            });
        }

        if (isShowUserRecommend) {
            tg.BackButton.show();
            tg.BackButton.onClick(() => {
                setCurrentPage('UserPage');
                setIsShowUserRecommend(false);
                setIsShowUserButtons(true);
            });
        } else if (isShowUserNotifications) {
            tg.BackButton.show();
            tg.BackButton.onClick(() => {
                setCurrentPage('UserPage');
                setIsShowUserNotifications(false);
                setIsShowUserButtons(true);
            });
        }

        return () => {
            tg.BackButton.offClick(() => {
                setCurrentPage('MapPage');
            });
            tg.BackButton.offClick(() => {
                setCurrentPage('AddEventPage');
            });
            tg.BackButton.offClick(() => {
                setCurrentPage('UserPage');
                setIsShowUserRecommend(false);
                setIsShowUserButtons(true);
            });
            tg.BackButton.offClick(() => {
                setCurrentPage('UserPage');
                setIsShowUserNotifications(false);
                setIsShowUserButtons(true);
            });
            tg.BackButton.hide();
        };
    }, [currentPage, isShowUserRecommend, isShowUserNotifications]);

    // геолокация
    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setUserlatitude(latitude);
                    setUserlongitude(longitude);
                    setMapCenter([latitude, longitude]);
                },
                (error) => {
                    console.error('Ошибка получения геолокации: ', error);
                    setUserlatitude(55.7522);
                    setUserlongitude(37.6156);
                    setMapCenter([55.7522, 37.6156]);
                    alert(
                        'Вы не предоставили разрешение на определение геолокации'
                    );
                }
            );
        } else {
            console.log('Определение геолокации не поддерживается');
            setUserlatitude(55.7522);
            setUserlongitude(37.6156);
            setMapCenter([55.7522, 37.6156]);
            alert('Определение геолокации не поддерживается вашим устройством');
        }
    }, []);

    // получение категорий
    const loadingCategories = async () => {
        try {
            const response = await axios.get(
                'https://mepointserver.ru/main/categories',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                        'Accept-Language': userLang,
                    },
                }
            );

            if (response.data.success) {
                setСategories(response.data.result);
                console.log('Категории: ', response.data.result);
            }
        } catch (error) {
            console.error('Ошибка получения категорий ', error);
        }
    };

    // авторизация
    useEffect(() => {
        const tg = window.Telegram.WebApp;
        const platform = tg.platform;

        if (window.Telegram) {
            tg.expand();
            tg.disableVerticalSwipes();
        }
        if (
            platform !== 'web' &&
            platform !== 'macos' &&
            platform !== 'windows' &&
            platform !== 'desktop' &&
            platform !== 'linux' &&
            platform !== 'tdesktop'
        ) {
            setIsFullScreenMode(true);
            tg.requestFullscreen();
            tg.lockOrientation();
        }
        if (!tg.initData) {
            alert('Ошибка данных телеграмма');
            return;
        }

        if (!tg.initDataUnsafe.user) {
            alert('Пользователь не найден');
            return;
        }
        const loadingData = async () => {
            const initData = window.Telegram.WebApp.initData;
            const language = localStorage.getItem('userLanguage');

            if (language) {
                try {
                    const response = await axios.post(
                        'https://mepointserver.ru/api/auth',
                        {
                            initData: initData,
                            avatarLink: null,
                            language: language,
                        },
                        {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        }
                    );
                    if (response.data.success) {
                        const token = response.data.result.token;
                        localStorage.setItem('authToken', token);

                        const isSubscribeChannel =
                            response.data.result.isSubscribeChannel;

                        console.log('Авторизация:', response.data.result);
                        console.log('userLang:', userLang);

                        if (isSubscribeChannel) {
                            loadingCategories();
                            setCurrentPage('MapPage');
                        } else {
                            if (language === 'ru-RU') {
                                setChannelLink('https://t.me/MePoint_RU');
                            } else {
                                setChannelLink('https://t.me/MePoint_EN');
                            }
                            setCurrentPage('SubscribePage');
                        }
                    } else {
                        console.log(
                            'Ошибка авторизации ',
                            response.data?.error
                        );
                    }
                } catch (error) {
                    console.error('Ошибка авторизации ', error);
                }
            } else {
                setCurrentPage('LanguagesPage');
            }
        };
        loadingData();
    }, []);

    // получение мероприятий
    const loadingEvents = async () => {
        try {
            const response = await axios.get(
                'https://mepointserver.ru/main/events',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                    params: {
                        latitude: userlatitude,
                        longitude: userlongitude,
                        typeDate: typeOfDate,
                        eventSubCategoryId: eventSubCategoryId,
                    },
                }
            );

            if (response.data) {
                setEvents(response.data.result);
                console.log('Мероприятия: ', response.data.result);
            }
        } catch (error) {
            console.error('Ошибка получения мероприятий ', error);
        }
    };

    // локация
    const handleRefreshClick = () => {
        setMapCenter([userlatitude, userlongitude]);
    };

    // перевод
    const translations = userLang === 'ru-RU' ? ruTranslations : enTranslations;

    return (
        <div className='App'>
            {currentPage === 'LoadingPage' && <LoadingPage />}
            {currentPage === 'LanguagesPage' && (
                <LanguagesPage
                    setCurrentPage={setCurrentPage}
                    setChannelLink={setChannelLink}
                    loadingCategories={loadingCategories}
                />
            )}
            {currentPage === 'SubscribePage' && (
                <SubscribePage
                    setCurrentPage={setCurrentPage}
                    channelLink={channelLink}
                    loadingCategories={loadingCategories}
                    translations={translations}
                    userLang={userLang}
                />
            )}
            {currentPage === 'MapPage' && (
                <MapPage
                    source='MainPage'
                    setCurrentPage={setCurrentPage}
                    mapCenter={mapCenter}
                    userlatitude={userlatitude}
                    userlongitude={userlongitude}
                    typeOfDate={typeOfDate}
                    eventSubCategory={eventSubCategory}
                    setEventInfo={setEventInfo}
                    eventSubCategoryId={eventSubCategoryId}
                    loadingEvents={loadingEvents}
                    events={events}
                />
            )}
            {currentPage === 'MapPage' && (
                <Search
                    setCurrentPage={setCurrentPage}
                    eventSubCategory={eventSubCategory}
                    isFullScreenMode={isFullScreenMode}
                />
            )}
            {currentPage === 'MapPage' && (
                <MapButton
                    handleRefreshClick={handleRefreshClick}
                    loadingEvents={loadingEvents}
                />
            )}
            {currentPage === 'MapPage' && (
                <AddEvent setCurrentPage={setCurrentPage} />
            )}
            {isShowNavigation &&
                [
                    'MapPage',
                    'UserPage',
                    'MePointPage',
                    'ChatPage',
                    'AddEventPage',
                    'EventJoinPage',
                    'ChatPage',
                    'TypeEventsPage',
                    'AddRecommendPage',
                ].includes(currentPage) && (
                    <NavigationPanel
                        setCurrentPage={setCurrentPage}
                        currentPage={currentPage}
                    />
                )}
            {currentPage === 'MapPage' && (
                <MapDate
                    setTypeOfDate={setTypeOfDate}
                    typeOfDate={typeOfDate}
                    translations={translations}
                    isFullScreenMode={isFullScreenMode}
                />
            )}
            {currentPage === 'TypeEventsPage' && (
                <TypeEvents
                    source='MainPage'
                    setCurrentPage={setCurrentPage}
                    categories={categories}
                    setEventSubCategory={setEventSubCategory}
                    translations={translations}
                    setEventSubCategoryId={setEventSubCategoryId}
                    isFullScreenMode={isFullScreenMode}
                />
            )}

            {currentPage === 'UserPage' && (
                <User
                    translations={translations}
                    userLang={userLang}
                    setCurrentPage={setCurrentPage}
                    isShowUserButtons={isShowUserButtons}
                    setIsShowUserButtons={setIsShowUserButtons}
                    isShowUserRecommend={isShowUserRecommend}
                    setIsShowUserRecommend={setIsShowUserRecommend}
                    isShowUserNotifications={isShowUserNotifications}
                    setIsShowUserNotifications={setIsShowUserNotifications}
                    isFullScreenMode={isFullScreenMode}
                />
            )}

            {currentPage === 'MePointPage' && (
                <MePoint
                    translations={translations}
                    isFullScreenMode={isFullScreenMode}
                />
            )}

            {currentPage === 'ChatPage' && (
                <Chat
                    userLang={userLang}
                    setIsShowNavigation={setIsShowNavigation}
                    isShowNavigation={isShowNavigation}
                    translations={translations}
                    isFullScreenMode={isFullScreenMode}
                />
            )}

            {currentPage === 'AddEventPage' && (
                <AddEvents
                    setCurrentPage={setCurrentPage}
                    newEventAddress={newEventAddress}
                    newEventCategory={newEventCategory}
                    newEventDate={newEventDate}
                    setNewEventDate={setNewEventDate}
                    newEventCoords={newEventCoords}
                    setNewEventCategory={setNewEventCategory}
                    setNewEventCoords={setNewEventCoords}
                    setNewEventAddress={setNewEventAddress}
                    newEventDescription={newEventDescription}
                    setNewEventDescription={setNewEventDescription}
                    newEventCount={newEventCount}
                    setNewEventCount={setNewEventCount}
                    translations={translations}
                    userLang={userLang}
                    newRecommendId={newRecommendId}
                    setNewRecommendId={setNewRecommendId}
                    isFullScreenMode={isFullScreenMode}
                />
            )}

            {currentPage === 'NewMapPage' && (
                <MapPage
                    source='NewEvents'
                    setCurrentPage={setCurrentPage}
                    mapCenter={mapCenter}
                    userlatitude={userlatitude}
                    userlongitude={userlongitude}
                    setNewEventAddress={setNewEventAddress}
                    setNewEventCoords={setNewEventCoords}
                    events={events}
                />
            )}

            {currentPage === 'NewRecommendMapPage' && (
                <MapPage
                    source='NewRecommend'
                    setCurrentPage={setCurrentPage}
                    mapCenter={mapCenter}
                    userlatitude={userlatitude}
                    userlongitude={userlongitude}
                    setNewRecommendAddress={setNewRecommendAddress}
                    setNewRecommendCoords={setNewRecommendCoords}
                    events={events}
                />
            )}

            {currentPage === 'NewTypeEvents' && (
                <TypeEvents
                    source='NewEvents'
                    setCurrentPage={setCurrentPage}
                    categories={categories}
                    setNewEventCategory={setNewEventCategory}
                    translations={translations}
                    isFullScreenMode={isFullScreenMode}
                />
            )}

            {currentPage === 'NewTypeRecommend' && (
                <TypeEvents
                    source='NewRecommend'
                    setCurrentPage={setCurrentPage}
                    categories={categories}
                    setNewRecommendCategory={setNewRecommendCategory}
                    translations={translations}
                    isFullScreenMode={isFullScreenMode}
                />
            )}

            {currentPage === 'EventJoinPage' && (
                <EventsJoin
                    eventInfo={eventInfo}
                    userLang={userLang}
                    setCurrentPage={setCurrentPage}
                    translations={translations}
                    isFullScreenMode={isFullScreenMode}
                />
            )}
            {currentPage === 'RecommendPage' && newEventCategory !== null && (
                <RecommendPage
                    setCurrentPage={setCurrentPage}
                    newEventCategory={newEventCategory}
                    userLang={userLang}
                    translations={translations}
                    setNewEventAddress={setNewEventAddress}
                    setNewRecommendId={setNewRecommendId}
                    isFullScreenMode={isFullScreenMode}
                />
            )}

            {currentPage === 'AddRecommendPage' && (
                <AddRecommendPage
                    setCurrentPage={setCurrentPage}
                    translations={translations}
                    newRecommendCategory={newRecommendCategory}
                    newRecommendNameRu={newRecommendNameRu}
                    newRecommendNameEn={newRecommendNameEn}
                    setNewRecommendNameRu={setNewRecommendNameRu}
                    setNewRecommendNameEn={setNewRecommendNameEn}
                    newRecommendDescriptionRu={newRecommendDescriptionRu}
                    newRecommendDescriptionEn={newRecommendDescriptionEn}
                    setNewRecommendDescriptionRu={setNewRecommendDescriptionRu}
                    setNewRecommendDescriptionEn={setNewRecommendDescriptionEn}
                    newRecommendAddress={newRecommendAddress}
                    newRecommendCoords={newRecommendCoords}
                    image={image}
                    setImage={setImage}
                    newRecommendDate={newRecommendDate}
                    setNewRecommendDate={setNewRecommendDate}
                    userLang={userLang}
                    setNewRecommendCategory={setNewRecommendCategory}
                    setNewRecommendAddress={setNewRecommendAddress}
                    setNewRecommendCoords={setNewRecommendCoords}
                    isFullScreenMode={isFullScreenMode}
                />
            )}
        </div>
    );
}

export default App;
